export default "__VITE_ASSET__DMAyEPti__";